import { render, staticRenderFns } from "./PortfolioDetails.vue?vue&type=template&id=2d608aef&scoped=true&"
import script from "./PortfolioDetails.vue?vue&type=script&lang=js&"
export * from "./PortfolioDetails.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioDetails.vue?vue&type=style&index=0&id=2d608aef&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d608aef",
  null
  
)

export default component.exports